import {
  ADMIN_PAYOUTS_LOADED,
  ADMIN_PAYOUTS_CLEAR,
} from '../../actions/actionTypes';

const initialState = {
  payouts: null,
};

function payouts(state = initialState, action) {
  switch (action.type) {
    case ADMIN_PAYOUTS_LOADED:
      return { ...state, payouts: action.payload.payouts };
    case ADMIN_PAYOUTS_CLEAR:
      return { ...state, payouts: null };
    default:
      return state;
  }
}

export default payouts;
